'use client'

import BlogCard from "@/components/blog";
import Image from "next/image";
import { useState } from "react";

const blogData = [
  {
    slug: "explore-3-way-ball-valve-functionality",
    image: "/images/img_untitled_design_9_1.png",
    title: "Explore 3-Way Ball Valve Functionality | Wonder Valves",
    author: "Drishti N.",
    category: "Ball Valves",
    date: "20 MAR",
    excerpt:
      "In today’s fast-paced industries, efficiency and reliability are paramount...",
  },
  {
    slug: "wonder-actuated-valves-trusted-flow-control-solutions",
    image: "/images/img_untitled_design_9_1.png",
    title: "Wonder Actuated Valves: Trusted Flow Control Solutions",
    author: "Drishti N.",
    category: "Automation of Valves",
    date: "28 JAN",
    excerpt:
      "When it comes to industrial flow control, Wonder actuated valves are a top choice...",
  },
];

const bannerData = {
  image: "/images/logo/product-banner.jpg",
  path: "Home",
  current: "Blog",
}

const categories = [
  { id: 1, name: "All" },
  { id: 2, name: "Automation of Valves" },
  { id: 3, name: "Ball Valves" },
  { id: 4, name: "Butterfly Valves" },
];

const Blog = () => {
  const [selectedCategoryId, setSelectedCategoryId] = useState(1);
  const selectedCategory =
    categories.find((cat) => cat.id === selectedCategoryId)?.name || "All";

  const filteredPosts =
    selectedCategory === "All"
      ? blogData
      : blogData.filter((post) => post.category === selectedCategory);

  return (
    <div data-component-id="src/app/blog/page.tsx:54:4" data-component-path="src/app/blog/page.tsx" data-component-line="54" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
      {/* Banner */}
      <section data-component-id="src/app/blog/page.tsx:56:6" data-component-path="src/app/blog/page.tsx" data-component-line="56" data-component-file="page.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22relative%20h-%5B300px%5D%20sm%3Ah-%5B350px%5D%20md%3Ah-%5B400px%5D%20lg%3Ah-%5B500px%5D%20w-full%22%7D" className="relative h-[300px] sm:h-[350px] md:h-[400px] lg:h-[500px] w-full">
        {/* Background Image */}
        <Image data-component-id="src/app/blog/page.tsx:58:8" data-component-path="src/app/blog/page.tsx" data-component-line="58" data-component-file="page.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22alt%22%3A%22Banner%22%2C%22className%22%3A%22object-cover%22%7D"
          src={bannerData.image}
          alt="Banner"
          fill
          priority
          className="object-cover"
        />

        {/* Dark overlay */}
        <div data-component-id="src/app/blog/page.tsx:67:8" data-component-path="src/app/blog/page.tsx" data-component-line="67" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-black%2F50%22%7D" className="absolute inset-0 bg-black/50" />

        {/* Content */}
        <div data-component-id="src/app/blog/page.tsx:70:8" data-component-path="src/app/blog/page.tsx" data-component-line="70" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20flex%20items-center%22%7D" className="absolute inset-0 flex items-center">
          <div data-component-id="src/app/blog/page.tsx:71:10" data-component-path="src/app/blog/page.tsx" data-component-line="71" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-screen-xl%20mx-auto%20w-full%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="max-w-screen-xl mx-auto w-full px-4 sm:px-6 lg:px-8">
            <div data-component-id="src/app/blog/page.tsx:72:12" data-component-path="src/app/blog/page.tsx" data-component-line="72" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-left%20space-y-3%20md%3Aspace-y-5%22%7D" className="text-left space-y-3 md:space-y-5">
              {/* Heading */}
              <h1 data-component-id="src/app/blog/page.tsx:74:14" data-component-path="src/app/blog/page.tsx" data-component-line="74" data-component-file="page.tsx" data-component-name="h1" data-component-content="%7B%22elementName%22%3A%22h1%22%2C%22className%22%3A%22font-bold%20text-gray-300%20text-xl%20sm%3Atext-3xl%20md%3Atext-5xl%20lg%3Atext-6xl%22%7D" className="font-bold text-gray-300 text-xl sm:text-3xl md:text-5xl lg:text-6xl">
                {bannerData.current}
              </h1>

              {/* Breadcrumb */}
              <p data-component-id="src/app/blog/page.tsx:79:14" data-component-path="src/app/blog/page.tsx" data-component-line="79" data-component-file="page.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20sm%3Atext-sm%20md%3Atext-lg%20text-gray-300%22%7D" className="text-xs sm:text-sm md:text-lg text-gray-300">
                {bannerData.path}{" "}
                <span data-component-id="src/app/blog/page.tsx:81:16" data-component-path="src/app/blog/page.tsx" data-component-line="81" data-component-file="page.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-primaryColor%20font-semibold%22%2C%22textContent%22%3A%22-%22%7D" className="text-primaryColor font-semibold">
                  - {bannerData.current}
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <div data-component-id="src/app/blog/page.tsx:91:6" data-component-path="src/app/blog/page.tsx" data-component-line="91" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-screen-xl%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%20py-10%22%7D" className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div data-component-id="src/app/blog/page.tsx:92:8" data-component-path="src/app/blog/page.tsx" data-component-line="92" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-4%20gap-8%22%7D" className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Blog Cards */}
          <div data-component-id="src/app/blog/page.tsx:94:10" data-component-path="src/app/blog/page.tsx" data-component-line="94" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-3%22%7D" className="lg:col-span-3">
            {filteredPosts.length > 0 ? (
              <div data-component-id="src/app/blog/page.tsx:96:14" data-component-path="src/app/blog/page.tsx" data-component-line="96" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20gap-6%22%7D" className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {filteredPosts.map((post, idx) => (
                  <BlogCard data-component-id="src/app/blog/page.tsx:98:18" data-component-path="src/app/blog/page.tsx" data-component-line="98" data-component-file="page.tsx" data-component-name="BlogCard" data-component-content="%7B%22elementName%22%3A%22BlogCard%22%2C%22%5Bspread%5D%22%3A%22true%22%7D" key={idx} {...post} />
                ))}
              </div>
            ) : (
              <p data-component-id="src/app/blog/page.tsx:102:14" data-component-path="src/app/blog/page.tsx" data-component-line="102" data-component-file="page.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-center%20text-gray-600%22%2C%22textContent%22%3A%22No%20blog%20found%20in%20.%22%7D" className="text-center text-gray-600">
                No blog found in <strong data-component-id="src/app/blog/page.tsx:103:33" data-component-path="src/app/blog/page.tsx" data-component-line="103" data-component-file="page.tsx" data-component-name="strong" data-component-content="%7B%22elementName%22%3A%22strong%22%7D">{selectedCategory}</strong>.
              </p>
            )}
          </div>

          {/* Sidebar */}
          <aside data-component-id="src/app/blog/page.tsx:109:10" data-component-path="src/app/blog/page.tsx" data-component-line="109" data-component-file="page.tsx" data-component-name="aside" data-component-content="%7B%22elementName%22%3A%22aside%22%2C%22className%22%3A%22lg%3Asticky%20lg%3Atop-24%22%7D" className="lg:sticky lg:top-24">
            <h4 data-component-id="src/app/blog/page.tsx:110:12" data-component-path="src/app/blog/page.tsx" data-component-line="110" data-component-file="page.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22text-lg%20font-semibold%20mb-3%20border-b%20pb-2%22%2C%22textContent%22%3A%22Categories%22%7D" className="text-lg font-semibold mb-3 border-b pb-2">
              Categories
            </h4>
            <ul data-component-id="src/app/blog/page.tsx:113:12" data-component-path="src/app/blog/page.tsx" data-component-line="113" data-component-file="page.tsx" data-component-name="ul" data-component-content="%7B%22elementName%22%3A%22ul%22%2C%22className%22%3A%22space-y-2%20text-sm%22%7D" className="space-y-2 text-sm">
              {categories.map((category) => (
                <li data-component-id="src/app/blog/page.tsx:115:16" data-component-path="src/app/blog/page.tsx" data-component-line="115" data-component-file="page.tsx" data-component-name="li" data-component-content="%7B%22elementName%22%3A%22li%22%7D"
                  key={category.id}
                  onClick={() => setSelectedCategoryId(category.id)}
                  className={`cursor-pointer px-2 py-1 rounded hover:bg-primaryColor/10 hover:text-primaryColor ${selectedCategoryId === category.id
                    ? "text-primaryColor font-semibold bg-primaryColor/10"
                    : ""
                    }`}
                >
                  {category.name}
                </li>
              ))}
            </ul>
          </aside>
        </div>
      </div>
    </div>
  );
}
export default Blog